import { siteApiSlice } from "../../app/siteApiSlice";
import { UserRole } from "../../app/userSlice";

export interface ReportIndexViewModel {
	site: string;
	role: UserRole;
	courseId?: number;
	showEnrollmentMessage: boolean;
	showPlagiarismReports: boolean;
}

export const reportsApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		reportsPage: build.query<ReportIndexViewModel, void>({
			query: () => ({
				url: `/Reports`,
			}),
		}),
	}),
});

export const { useReportsPageQuery } = reportsApiSlice;
